<template>
  <div>

    <v-app >

    <div v-if="isChecked" class="overflow-y-hidden overflow-x-hidden">

      <router-view/>
    </div>
    <Footer v-if="isChecked" class="d-none d-sm-block"/>
  </v-app>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>

  </div>
</template>

<script>
import Footer from "@/components/Footer";

export default {
  name: "App",
  components: { Footer, },
  data: () => ({
    isBuyer:null,
    isSeller:null,
    isLoggedIn:false,
    isChecked:false,
    showLoaderDialog:true,

    //
  }),
  mounted() {

    this.silentLogin()
    this.$store.commit('getProductList')
    this.$store.commit('getHashtags')

  },
  methods:{
    silentLogin() {
      let userDate = this.$getUserData()
      if (userDate.mobile !== undefined && userDate.mobile !== null && userDate.mobile !== '' && userDate.activeCode !== undefined && userDate.activeCode !== null && userDate.activeCode !== '') {

        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        let urlencoded = new URLSearchParams();
        urlencoded.append("PhoneNumber", userDate.mobile);
        urlencoded.append("Password", userDate.activeCode);

        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        let resStatus = null;
        fetch(this.$baseUrl + "Home/Login", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              if (resStatus === 200) {
                let json = JSON.parse(result)
                this.$setUserData(userDate.mobile, userDate.activeCode, 'Bearer ' + json.JwtToken, json.Role);
                this.$store.commit('setToken', 'Bearer ' + json.JwtToken)
                this.$store.commit('setRole', json.Role)
                this.$store.commit('setIsLoggedIn', true)
                this.$store.commit('addProductToCart')
                if (json.Role === 4) {
                  // this.getClientLikeList();
                  this.isBuyer = true
                } else if (json.Role === 3) {
                  this.isSeller = true
                }
                this.isLoggedIn = true
                this.getUserSaves()
                this.showLoaderDialog=false
              } else {
                this.$store.commit('setIsLoggedIn', false)
                this.isLoggedIn = false
                this.isSeller = false
                this.isBuyer = false
                this.isChecked= true
                this.showLoaderDialog=false
              }
            })
            .catch(error => console.log('error', error));
      } else {
        this.isLoggedIn = false
        this.isSeller = false
        this.isChecked= true
        this.isBuyer = false
        this.showLoaderDialog=false
        this.$store.commit('setIsLoggedIn', false)


      }
    },
    getUserSaves() {
      if (this.isBuyer) {
        this.getBuyerProductBookMark()
        this.getBuyerFollowing()
        this.getBuyersPostsLikes()
        this.getBuyersPostBookmark()
      } else if (this.isSeller) {
        this.getSellerProductBookMark()
        this.getSellerFollowing()
        this.getSellerPostsLikes()
        this.getSellerPostBookmark()
      }
      this.isChecked= true
    },
    getBuyerProductBookMark() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/BookMarkProduct/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserBookmark', json)

          })
          .catch(error => console.log('error', error));
    },
    getBuyerFollowing() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/BookMarkVendor/_FollowingList", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserFollowing', json)
          })
          .catch(error => console.log('error', error));
    },
    getBuyersPostsLikes() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/Dashboard/ListSocialNetworkLike", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserPostsLikes', json)
          })
          .catch(error => console.log('error', error));
    },
    getBuyersPostBookmark(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ClientPanel/BookMarkVendor/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let posts = json.list.filter(x=>x.TypeBookMark === 3)
            this.$store.commit('addUserPostsBookMarks', posts)

          })
          .catch(error => console.log('error', error));
    },
    getSellerProductBookMark() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/BookMarkProduct/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserBookmark', json)
          })
          .catch(error => console.log('error', error));
    },
    getSellerFollowing() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/BookMarkVendor/_FollowingList", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserFollowing', json)
          })
          .catch(error => console.log('error', error));
    },
    getSellerPostsLikes() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/Dashboard/ListSocialNetworkLike", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.$store.commit('addUserPostsLikes', json)
          })
          .catch(error => console.log('error', error));
    },
    getSellerPostBookmark(){
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/BookMarkVendor/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let posts = json.filter(x=>x.TypeBookMark === 3)
            this.$store.commit('addUserPostsBookMarks', posts)

          })
          .catch(error => console.log('error', error));
    },
  }
};
</script>
